import { useState } from 'react';

const FORM_SUBMIT_URL = 'https://readdy.ai/api/form/d9slset8o1vn02ekuhlg';

export default function HomeContact() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const phoneAltInput = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (phoneAltInput && phoneAltInput.value.trim() !== '') {
      setFormStatus('success');
      setFormError('');
      form.reset();
      return;
    }

    setFormStatus('submitting');
    setFormError('');

    try {
      const formData = new FormData(form);
      if (phoneAltInput) {
        formData.delete('phone_alt');
      }

      const response = await fetch(FORM_SUBMIT_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;

      if (
        response.ok &&
        parsed &&
        parsed.code === 'OK'
      ) {
        setFormStatus('success');
        form.reset();
      } else {
        setFormStatus('error');
        setFormError(
          typeof serverMsg === 'string' && serverMsg.includes('spam')
            ? '提交失败，请稍后重试'
            : typeof serverMsg === 'string'
              ? serverMsg
              : '提交失败，请稍后重试'
        );
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请检查您的网络连接后重试');
    }
  };

  if (formStatus === 'success') {
    return (
      <section id="contact" className="py-14 md:py-20 bg-background-50">
        <div className="max-w-xl mx-auto px-4 md:px-6 text-center">
          <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-green-100 text-green-600">
            <i className="ri-check-line text-2xl"></i>
          </div>
          <h2 className="text-2xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            提交成功！
          </h2>
          <p className="mt-3 text-foreground-600">
            感谢您的留言，我们会尽快回复您。蜜芽永不失联，随时为您服务。
          </p>
          <button
            onClick={() => setFormStatus('idle')}
            className="mt-6 px-6 py-2 bg-primary-500 text-white rounded-md text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            继续留言
          </button>
        </div>
      </section>
    );
  }

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            联系我们
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            有任何问题或建议？请随时与我们联系，蜜芽永不失联
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="space-y-4"
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1">
                姓名 <span className="text-red-500">*</span>
              </label>
              <input
                id="contact-name"
                type="text"
                name="name"
                required
                className="w-full px-3 py-2 border border-background-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent bg-white"
                placeholder="请输入您的姓名"
              />
            </div>
            <div>
              <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1">
                邮箱 <span className="text-red-500">*</span>
              </label>
              <input
                id="contact-email"
                type="email"
                name="email"
                required
                className="w-full px-3 py-2 border border-background-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent bg-white"
                placeholder="请输入您的邮箱"
              />
            </div>
          </div>

          <div>
            <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1">
              主题 <span className="text-red-500">*</span>
            </label>
            <input
              id="contact-subject"
              type="text"
              name="subject"
              required
              className="w-full px-3 py-2 border border-background-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent bg-white"
              placeholder="请输入留言主题"
            />
          </div>

          <div>
            <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1">
              留言内容 <span className="text-red-500">*</span>
            </label>
            <textarea
              id="contact-message"
              name="message"
              required
              maxLength={500}
              rows={4}
              className="w-full px-3 py-2 border border-background-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent bg-white resize-none"
              placeholder="请输入您的留言内容（不超过500字）"
            ></textarea>
            <p className="text-xs text-foreground-500 mt-1">最多500个字符</p>
          </div>

          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="absolute opacity-0 pointer-events-none"
            style={{ position: 'absolute', left: '-9999px', top: '-9999px' }}
          />

          {formStatus === 'error' && formError && (
            <p className="text-sm text-red-600">{formError}</p>
          )}

          <button
            type="submit"
            disabled={formStatus === 'submitting'}
            className="w-full py-2.5 bg-primary-500 text-white rounded-md text-sm font-medium hover:bg-primary-600 transition-colors disabled:opacity-50 cursor-pointer whitespace-nowrap"
          >
            {formStatus === 'submitting' ? '提交中...' : '提交留言'}
          </button>
        </form>
      </div>
    </section>
  );
}